var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('loading') : _vm._e(), _c('Header', {
    attrs: {
      "showMemberCenter": false,
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top__item"
  }, [_c('div', {
    staticClass: "top__title"
  }, [_vm._v("已成功邀請")]), _c('div', {
    staticClass: "top__num"
  }, [_c('b', [_vm._v(_vm._s(_vm.successCount))]), _vm._v(" /人")])]), _vm._m(0)]), _c('div', {
    staticClass: "invite-list"
  }, _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item,
      staticClass: "invite-list__item"
    }, [_c('MgmProfileAvatar', {
      attrs: {
        "pic_url": item.pic_url
      }
    }), _c('div', {
      staticClass: "description"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date) + " 邀請")])]), _c('div', {
      staticClass: "status"
    }, [item.isInvited ? _c('img', {
      attrs: {
        "src": require("./images/stamp-success.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("./images/stamp-process.png")
      }
    })])], 1);
  }), 0)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top__item"
  }, [_c('div', {
    staticClass: "top__title"
  }, [_vm._v("己完成兌換")]), _c('div', {
    staticClass: "top__num"
  }, [_c('b', [_vm._v("1")]), _vm._v(" /次")])]);
}]

export { render, staticRenderFns }